import axios from 'axios'
import { inventoryID } from 'load/inventory/fns/inventoryID'
import { state } from 'state'

export const bootstrap = {
  initialize(id) {
    console.log('DEBUG (bootstrap) Bootstrapping services.')

    MK.axios = MK.axios || axios

    if (MK.page.inventoryCapable[MK.page.type]) {
      console.log('DEBUG (bootstrap) Page is inventory-capable.')
      try {
        id = inventoryID()
        console.log(`DEBUG (bootstrap) Inventory ID: ${id}`)
        if (!inventoryID) throw new Error(`!!! ERROR (bootstrap) Unable to determine inventory ID for ${window.location.href}`)

        // MK.inventoryPath = `${process.env.INVENTORY_PATH}${id}.json`
        MK.inventoryDomain = (/eddiebauer\.ca/.test(window.location.host) ? 'eddiebauer.ca' : 'eddiebauer.com')
        // MK.inventoryPath = `https://static.marketreach.io/${MK.inventoryDomain}/json/inv/${id}.json`


        // MK.inventoryPath = `${process.env.INVENTORY_PATH}/${id}.json`
        MK.inventoryPath = `${process.env.INVENTORY_ROOT_URL_PATH}/${id}.json`



        // MK.inventoryPath = `https://static.marketreach.io/${MK.tld}/json/inv/${id}.json`
        // MK.inventoryPath || `https://static.marketreach.io/${MK.tld}/json/inv/${id}.json`
        axios.get(`${MK.inventoryPath}`)
          .then(response => state.initialize(response.data))
          .catch(error => MK.capturePromiseRejection && MK.capturePromiseRejection(error))
      } catch (error) {
        console.log(error)
        MK.captureException && MK.captureException(error)
      }
    }

    // * Initialize page events
    import( /* webpackMode: "lazy", webpackChunkName: "page", webpackPreload: true */ 'page').then(bundle => bundle.page.initialize()).catch(error => MK.capturePromiseRejection(error))

    // * Initialize coupons, when needed.
    MK.page.type === 'coupons' &&
      import( /* webpackMode: "lazy", webpackChunkName: "coupons" */ 'load/coupons')
        .then(bundle => bundle.default.initialize(axios))
        .catch(error => MK.capturePromiseRejection(error))
  }
}